export default __webpack_public_path__ + "static/media/Orpen-Kisacikoglu.774c3f7e.png";